import {nanoid} from 'nanoid';
import {transliterateRuToUpperCase} from './transliteration';

export function getModelName(name: string, modelName?: string): string {
  return modelName ?? `${transliterateRuToUpperCase(name)}_${nanoid(6)}`;
}
